import { UserModel } from "src/app/modules/admin/user-management/user-model";

export class UserStatusModel {
    userId: string;
    user: UserModel;
    lastActive: Date | string | null;
    status: number;
}